import React, { useState } from 'react';

export const useCustomAmountInput = () => {
  // Stores the unformatted raw value (e.g., 111111.23)
  const [rawCustomAmountInputValue, setRawCustomAmountInputValue] = useState<
    number | null
  >(null);
  // Stores the formatted value with commas (e.g., 111,111.23)
  const [formattedCustomAmountInputValue, setFormattedCustomAmountInputValue] =
    useState('');

  const handleCustomAmountInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const inputValue = e.target.value;

    const rawValue = Number(inputValue.replace(/,/g, ''));
    setRawCustomAmountInputValue(rawValue);

    // Allow only digits, commas, and up to one period
    const regex = /^[\d,]*\.?\d*$/;
    if (!regex.test(inputValue)) {
      return; // Ignore invalid input
    }

    const formatted = formatToUSD(inputValue);
    setFormattedCustomAmountInputValue(formatted);
  };

  return {
    rawCustomAmountInputValue,
    formattedCustomAmountInputValue,
    handleCustomAmountInputChange,
  };
};

const formatToUSD = (value: string): string => {
  if (!value) return '';

  const [integerPart, decimalPart] = value.split('.');

  // Format the integer part with commas
  const formattedIntegerPart = parseInt(
    integerPart.replace(/,/g, '') || '0',
    10,
  ).toLocaleString('en-US');

  const slicedDecimalPart = decimalPart?.slice(0, 2);

  return decimalPart !== undefined
    ? `${formattedIntegerPart}.${slicedDecimalPart}`
    : formattedIntegerPart;
};
